import { Observable } from 'rxjs';

export interface LoadAllFacade {
  loadAll: (params?: unknown) => void;
}

export interface LoadDataFacade extends LoadAllFacade {
  loaded$: Observable<boolean>;
}
